import * as Sentry from '@sentry/react';
import { SeverityLevel } from '@sentry/react';

export const sentryConfig = {
  dsn: 'https://b7c532f28d40f02328083f86125270de@o55978.ingest.us.sentry.io/4507901407592448',
  environment: process.env.REACT_APP_ENVI,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', process.env.HOME_BASE_URL || ''],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
};

const captureMessage = (message: string, severityLevel: SeverityLevel) => {
  if (Sentry.isInitialized()) {
    Sentry.captureMessage(message, severityLevel);
  }
};

/**
 * Creates and returns Sentry Logger singleton (assumes that Sentry.init() has been called)
 *
 * Example usage:
 *
 *  import Logger from "services/sentry/sentry";
 *  const error = new Error("Something terrible has happened");
 *  Logger.error(error, {
 *     extra: {
 *       test: 'test',
 *       test2: 'test2',
 *     },
 *   });
 */
export default {
  info: (message: string) => {
    captureMessage(message, 'info');
  },
  warn: (message: string) => {
    captureMessage(message, 'warning');
  },
  debug: (message: string) => {
    captureMessage(message, 'debug');
  },
  error: (exception: any, ...args: any[]) => {
    if (Sentry.isInitialized()) {
      Sentry.captureException(exception, ...args);
    }
  },
};
